import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { UniqueHelper } from '../helpers/unique.helper';

export const uniqueBranchNamesValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.value || !Array.isArray(control.value)) return null;

  const names = control.value
    .map((branch) => branch.name)
    .filter((name) => !!name);
  const duplicates = UniqueHelper.getDuplicates(names);

  return !duplicates.length ? null : { uniqueBranchNames: duplicates };
};
